import React, { useEffect, useState } from 'react'
import { CancelButton, SubmitButton } from '../../../../Components/Utils/Buttons';
import FormikSelectTwo from '../../../../Components/Utils/Select';
import NuDateFormat from '../../../../Components/Utils/NuDate';
import CloseIcon from '../../../../Components/Icons/Close';

import MultiEdit from './MultiEdit';
import CustomDataTable from '../../../../Components/Others/CustomDataTable';
import { GetAccess, GetNotUseRole } from '../../../../Components/Utils/roles';

import axiosInstance from '../../../../Services/axiosCommon';
import { useFormik } from 'formik';
import UseGetDataSearchByProUser from '../../../../Components/Hooks/useFetchDataByPROUser';
import { useLocation } from 'react-router-dom';
import * as yup from 'yup';
import UseGetDataSearch from '../../../../Components/Hooks/useFetchDataBySearch';
import useFetchMDIndex from '../../../../Components/Hooks/useFetchMDIndex';
import { NuDate } from '../../../../Components/Utils/Input';
import UseDropDown from '../../../../Components/Hooks/useDropDown';

import TeamMemberLayout from '../TeamMemberLayout';
import Pagination from '../../../../Components/Utils/Pagenation';
import TeamCard from './TeamCard';
import MobileTeam from '../../../Mobile/Team/MobileTeam';
import UseGetDataSearchByPro from '../../../../Components/Hooks/useFetchDataByPRO';
import useFetchMataData from '../../../../Components/Hooks/useFetchMataData';
import ImportFileModal from '../../../../Components/Utils/ImportFileComponent';




function TeamIndex() {
  const [screenSize, setScreenSize] = useState({
         width: window.innerWidth,
       });
     
       useEffect(() => {
         const handleResize = () => {
           setScreenSize({
             width: window.innerWidth,
           });
         };
     
         window.addEventListener("resize", handleResize);
     
         return () => {
           window.removeEventListener("resize", handleResize);
         };
       }, []);
 
   const [open, setOpen] = useState(false);
   const location = useLocation();
   const state = location.state;
     const currentPage = location.state?.currentPage;
   const searchQuery = location.state?.searchQuery;
   const [page, setPage] = useState(currentPage || 1);
   const [pageCount, setPageCount] = useState(
     localStorage.getItem("perPageView") || 20
   );
   const [filter, setFilter] = useState(state?.industry ? true : false);
   const [showFilterDialog, setShowFilterDialog] = useState(false);
   const [showExport, setShowExport] = useState(false);

  //  const {value:status} = useFetchMDIndex
  //  (`/dropdown/dropdown-details/`,'Status_Schedule',[showFilterDialog, showExport],
  //   () => showFilterDialog || showExport)
  const { value: Inspector_Status, getData: refInspector_Status } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "Inspector_Status"
  );
  const { value: Inspection_Team, getData: refInspection_Team } = useFetchMataData(`/dropdown/dropdown-details/`, "Inspection_Team");

              const { data: user } = UseDropDown(`/user/new-drop-down`);
   
   const [filterProps, setFilterProps] = useState({
     status:"",
     division:"",
    
   });
   const [params, setParams] = useState({
     page: page,
     per_page: pageCount,
      search:searchQuery||"",
     status:"",
     division:"",
    
   });
   const clearFilter = () => {
     setParams({
       ...params,
 
       status:"",
       division:"",
      
     });
     formik.values.status = "";
     formik.values.division = "";
    

     setFilter(false);
   };
 
   const formik = useFormik({
     enableReinitialize: true,
     initialValues: filterProps,
     validateOnChange: false,
     validateOnBlur: false,
     validationSchema: yup.object({
       // email: yup.string().required('Email is required!'),
     }),
     onSubmit: async (value, { resetForm }) => {
       console.log("ffff", value);
       setParams({ ...params, status: value.status,division: value.division });
       closeFilterDialog();
       setFilter(true);
       setFilterProps({
        status:"",
        division:"",
       });
     },
   });
   const { data, totalCount,getData, dataLoading } = UseGetDataSearchByPro(
     `/team/`,
     params
   );
   const [viewMode, setViewMode] = useState(
     localStorage.getItem("viewMode") || "card"
   );
 
 
 
  const defaultHeader = [
  {
    title: "Name",
    width: "20%",
    isLink: true,
    id: "id",
    link: `/teammember/team/view/`,
    field: "name",
    textAlign: "left",
    rowAlign: "left",
  },
  {
    title: "Designation",
    width: "15%",
    field: "designation",
    textAlign: "left",
    rowAlign: "left",
   
  },
  {
    title: "Division",
    width: "15%",
    field: "division",
    textAlign: "left",
    rowAlign: "left",
    isLink: true,
    id: "id",
    link: `/teammember/team/view/`,
  },
    {
    title: "Mobile",
    width: "15%",
    field: "phoneWithCC",
    textAlign: "left",
    rowAlign: "left",
  },
  {
    title: "Email",
    width: "15%",
    field: "email",
    type : 'email',
    textAlign: "left",
    rowAlign: "left",
  },
 
  
  
  {
    title: "Status",
    width: "10%",
    field: "status",
    textAlign: "center",
    rowAlign: "center",
   
    
  },
  {
    title: "Action",
    width: "10%",
    field: "action",
    textAlign: "center",
    rowAlign: "center",
    contents: {
      id: "id",
      removeValue: "name",
      url: `/team/`,
      moduleName: "Team Member",
      from: `/teammember/team`,
      editLink: `/teammember/team/edit/`,
      viewLink: `/teammember/team/view/`
    }
  }
];
   const availableHeaders = [
    
   ];
   useEffect(() => {
     localStorage.setItem("viewMode", viewMode);
     setParams({ ...params, page: page, per_page: pageCount });
   }, [page, pageCount, viewMode]);
 
   const closeFilterDialog = () => {
     setShowFilterDialog(false);
   };
   const [showImportModal, setShowImportModal] = useState(false);
 
   const handleImportClick = () => {
     setShowImportModal(true);
   };
 
   const closeModal = () => {
     setShowImportModal(false);
   };
   const [exportValue, setExportValue] = useState({
   division:"",
   status:"",
   });
   const ExportFormik = useFormik({
     enableReinitialize: true,
     initialValues: exportValue,
     validateOnChange: false,
     validateOnBlur: false,
     onSubmit: async (value, { resetForm }) => {
       try {
         const response = await axiosInstance.get(
           `/team/export?division=${value.division}&status=${value.status}`,
           {
             responseType: "blob",
           }
         );
 
         const pdfBlob = new Blob([response.data], {
           type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
         });
 
         const link = document.createElement("a");
         link.href = window.URL.createObjectURL(pdfBlob);
         link.download = `Team Report ${NuDateFormat({
           value: new Date(),
           format: "DD-MMM-YYYY",
         })}.xlsx`;
 
         document.body.appendChild(link);
         link.click();
 
         link.parentNode.removeChild(link);
       } catch (error) {
         console.error("Error downloading the PDF:", error);
       }
     },
   });
   const closeFilterDialogebox = () => {
     setShowExport(false);
   };
 
   const [showEdit, setShowEdit] = useState(false);
   const [listofNumbers, setListofNumbers] = useState([]);
   const [fullList, setFullList] = useState([]);
 
   const selectOneFunction = (value) => {
     console.log("sss", value);
 
     let NewId;
     if (listofNumbers && listofNumbers.some((Item) => Item === value)) {
       NewId = listofNumbers.filter((Temp) => Temp !== value);
       setListofNumbers(NewId);
     } else {
       setListofNumbers([...listofNumbers, value]);
     }
     console.log("sss", listofNumbers);
   };
 
   const selectMultipleFunction = (e) => {
     if (e.target.checked) {
       console.log("if List", fullList);
       setListofNumbers(fullList);
     } else {
       console.log("else List", fullList);
       setListofNumbers([]);
     }
   };
 
   useEffect(() => {
     let tempArr = [];
     data &&
       data.forEach((i) => {
         console.log("I", i);
         tempArr.push(i?.id);
       });
     setFullList(tempArr);
   }, [data]);
 
   const [valueOfSearch,setValuesofSearch] = useState("")
   function searchFunction(e) {
 
     
     setValuesofSearch(e?.target?.value)
     setParams({ ...params, search: e?.target?.value, page:1 });
     setPage(1)
   }
 
   
   return (
     <>
 <TeamMemberLayout 
       setOpen={setShowImportModal}
       searchFun={searchFunction}
       setOpenExport={setShowExport}
 
         getData={getData}
         isCard={true}
         isFilter={filter}
          newfilter={true}
         setFilterOpen={setShowFilterDialog}
         ClearFilter={clearFilter}
         CreateAccess={GetAccess("team_create")}
         ImportAccess={GetAccess("team_import")}
         ExportAccess={GetAccess("team_export")}
 
             searchValue={valueOfSearch}
         setViewMode={setViewMode}
         neededSearch={true}
         viewMode={viewMode}
         // handleSearch={handleSearch}
      total={totalCount}

         >
               {
   screenSize.width <= "786" ?(<>
   <div className=' w-full h-[calc(100vh-205px)] bg-white mt-1 rounded-lg shadow-lg overflow-hidden'>
   <MobileTeam
   data={data}
   total={totalCount}
   pageIndex={page}
   setPageIndex={setPage}
   dataCount={pageCount}
   setDataCount={setPageCount}

   getData={getData}
 
   />
   </div>
   </>):(<>
     <div className="w-full h-full ">
         {viewMode === "list" ? (

      <CustomDataTable 
      fetcher={getData}
        data={data} 
        availableHeaders={availableHeaders} 
        defaultHeader={defaultHeader}
        bodyHeight='max-h-[calc(100vh-260px)]'
        height='h-[calc(100vh-160px)]'
        total={totalCount}
        pageIndex={page}
        setPageIndex={setPage}
        dataCount={pageCount}
        setDataCount={setPageCount}
        title='Teams'
        storageName="TeamTable"
        selectOneFunction={selectOneFunction}
        // setShowDelete={setShowDelete}
        // showDelete={showDelete}
        setShowEdit={setShowEdit}
        showEdit={showEdit}
        listofNumbers={listofNumbers}
        hasMultiEdit={true}
        selectMultipleFunction={selectMultipleFunction}
        fullList={fullList}
        getById="TeamId"
        editAccess="team_edit"      
        deteleAccess="team_delete" 
        dataLoading={dataLoading}
        searchQuery={params?.search!=""?params?.search:""}
        // dateShow={true}
        />

      ) : (
        <>
        <div className='w-full h-[calc(100vh-210px)] lg:h-[calc(100vh-190px)] rounded-md bg-white p-3 mt-0.5 relative overflow-y-scroll'>
       
          <div className='w-full flex justify-start flex-wrap md:gap-x-5 lg:gap-x-6 gap-y-6 pt-4'>
            
            {data && data.map((item, idx) => (
              <TeamCard fetcher={getData}  item={item} key={idx} />
            ))}
          </div>
        </div>
        <div className="w-full h-[40px] rounded-b-md bg-white">
          <Pagination
            total={totalCount}
            pageIndex={page}
            setPageIndex={setPage}
            dataCount={pageCount}
            setDataCount={setPageCount}
          />
        </div>
        </>
      )}
    </div>

</>)}
       </TeamMemberLayout>
      
       {showFilterDialog && (
         <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
           <div className="animate-scale-in min-w-[40%] max-w-[80%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
             <h2 className="text-xl mb-4">Filter </h2>
             <form onSubmit={formik.handleSubmit}>
               <div className="flex flex-col mb-4">
              <FormikSelectTwo
              label="Division"
              Options={Inspection_Team}
              formik={formik}
              placeholder="Choose"
              name="division"

              width="w-full "
            />
              <FormikSelectTwo
                           type="text"
                           label="Status "
                           placeholder="Status"
                           Options={Inspector_Status}
                           formik={formik}
                           name="status"
                           width="w-full "
                         />
               </div>
               <div className="flex justify-end gap-2">
                 <CancelButton handleClick={closeFilterDialog} />
                 <SubmitButton name="Apply" />
               </div>
             </form>
           </div>
         </div>
       )}
 
       {showEdit && (
         <MultiEdit
           data={listofNumbers}
           getData={getData}
           onClose={() => setShowEdit(false)}
         />
       )}
      
      {showImportModal && (
        <ImportFileModal
          show={showImportModal}
          onClose={closeModal}
        apiUrl="/team/import"
        menuName="Team"
        getData={getData}
        />
        
      )}
      {showExport && (
              <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
                <div className="animate-scale-in min-w-[85%]  sm:min-w-[50%] 2xl:min-w-[40%] max-w-[50%] 2xl:max-w-[40%] max-h-[80vh] relative bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
                  <div className=" w-full flex justify-between items-center  bg-white">
                    <h2 className=" text-sm 2xl:text-base font-medium ">
                      Export Data
                    </h2>
                    <div
                      className=" cursor-pointer "
                      onClick={() => setShowExport(false)}
                    >
                      <CloseIcon />
                    </div>
                  </div>
                  <form onSubmit={ExportFormik.handleSubmit}>
                    <div className=" w-full flex flex-wrap">
                      <div className=" w-full flex ">
                        <div className=" w-1/2 flex items-center px-6 py-3 ">
                          <input
                            id="default-radio-1"
                            type="radio"
                            value="all"
                            name="type"
                            className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300"
                            onChange={ExportFormik.handleChange}
                            checked={ExportFormik.values.type =="all"}
                          />
                          <label
                            htmlFor="default-radio-1"
                            className="ms-2 text-xs 2xl:text-sm  text-gray-900 "
                          >
                            All Data
                          </label>
                        </div>
      
                        <div className="w-1/2 flex items-center px-6 py-3">
                          <input
                            id="default-radio-2"
                            type="radio"
                            value="filter"
                            name="type"
                            className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300"
                            onChange={ExportFormik.handleChange}
                            checked={ExportFormik.values.type == "filter"}
                          />
                          <label
                            htmlFor="default-radio-2"
                            className="ms-2 text-xs 2xl:text-sm  text-gray-900"
                          >
                            Filter Data
                          </label>
                        </div>
                      </div>
                      {ExportFormik.values.type === "filter" && (
                        <>
                            <FormikSelectTwo
              label="Division"
              Options={Inspection_Team}
              formik={formik}
              placeholder="Choose"
              name="division"

              width="w-full "
            />
              <FormikSelectTwo
                           type="text"
                           label="Status "
                           placeholder="Status"
                           Options={Inspector_Status}
                           formik={formik}
                           name="status"
                           width="w-full "
                         />
      
                        </>
                      )}
                      <div className="flex w-full justify-end gap-2">
                        <CancelButton handleClick={closeFilterDialogebox} />
                        <SubmitButton name="Export" />
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            )}
     </>
   );
 }

export default TeamIndex
